import { render, staticRenderFns } from "./foot.vue?vue&type=template&id=2b2c6a41&scoped=true&"
var script = {}
import style0 from "./foot.vue?vue&type=style&index=0&id=2b2c6a41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2c6a41",
  null
  
)

export default component.exports